// src/js/index.js
import { Application } from "@hotwired/stimulus";
import TrackerController from "./controllers/tracker_controller";

const application = (window.RedmineTimeTrackerStimulusApp = Application.start());
application.register("tracker", TrackerController);

// If Turbo is not available on the page and you want to use it, you can import it
// but in production we avoid forcing it. Redmine 6 includes Turbo; Redmine 5 does not.
// If you need Turbo features, enable the import and include the runtime in bundle.
